// Direct QuePasa Channel group service using this plugin's own endpoints.
const GROUP_CACHE_TTL = 30000;
const detailsCache = new Map();
const http = () => window.axios;
const key = (a, i, g) => `${a}:${i}:${g}`;

const groupsService = {
  async details(accountId, inboxId, groupId, { force = false } = {}) {
    const k = key(accountId, inboxId, groupId);
    const cached = detailsCache.get(k);
    if (!force && cached && Date.now() - cached.timestamp < GROUP_CACHE_TTL) {
      return cached.data;
    }
    const { data } = await http().get(
      `/api/v1/accounts/${accountId}/quepasa_channel/${inboxId}/groups/details`,
      { params: { group_id: groupId } }
    );
    detailsCache.set(k, { timestamp: Date.now(), data });
    return data;
  },

  async invite(accountId, inboxId, groupId) {
    const { data } = await http().get(
      `/api/v1/accounts/${accountId}/quepasa_channel/${inboxId}/groups/invite`,
      { params: { group_id: groupId } }
    );
    return data;
  },

  async updateParticipants(
    accountId,
    inboxId,
    groupId,
    participants,
    action = 'add'
  ) {
    const { data } = await http().post(
      `/api/v1/accounts/${accountId}/quepasa_channel/${inboxId}/groups/participants`,
      { group_id: groupId, participants, group_action: action }
    );
    detailsCache.delete(key(accountId, inboxId, groupId));
    return data;
  },

  async importContacts(accountId, inboxId, groupId) {
    const { data } = await http().post(
      `/api/v1/accounts/${accountId}/quepasa_channel/${inboxId}/groups/import`,
      { group_id: groupId }
    );
    return data;
  },
};

export default groupsService;
